export default __webpack_public_path__ + "static/Corporate_Responsibility_ReponsibleSourcing_03-9ff6ff195e7d10b86a5d08c4417c3164.jpg";